import { ConnectComponent } from "util";
import View from "./app.view";
import Presenter from "./app.presenter";

export default ConnectComponent(View, Presenter);



// WEBPACK FOOTER //
// ./src/components/app/index.js